import { useState } from 'react'
import styled from 'styled-components'

import { Info1Icon, Tooltip } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { TooltipDrawer, Separator } from '@root/shared/ui-kit'

import type { DeviceType } from '@blade/ui-kit'

type Props = {
  onChange: (url: string) => void
  device: DeviceType
}
const TG_LINK_REGEX = new RegExp('^(https://)?t.me/.+', 'i')
export const BuyPremiumFormLink: React.FC<Props> = ({ onChange, device }) => {
  const { t } = useTranslation()
  const [isValid, setValid] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const url = event.target.value
    const match = TG_LINK_REGEX.test(url)

    onChange(match ? url : '')
    setValid(match)
  }

  const renderTooltip = (el: React.ReactElement<{ onClick?: () => void }>) => {
    if (device === 'mobile') {
      return (
        <TooltipDrawer
          title={t('premium.pay.portal-link.title')}
          content={t('premium.pay.portal-link.info-text')}
        >
          {el}
        </TooltipDrawer>
      )
    }
    return (
      <Tooltip content={t('premium.pay.portal-link.info-text')}>{el}</Tooltip>
    )
  }

  return (
    <Root>
      <Label>{t('premium.pay.subscription.link')}</Label>

      <Address>
        <Input
          type="url"
          $isValid={isValid}
          placeholder={t('premium.pay.subscription.link-placeholder')}
          onChange={handleChange}
        />
        <Separator vertical />
        {renderTooltip(
          <IconWrapper>
            <Info1Icon />
          </IconWrapper>,
        )}
      </Address>
    </Root>
  )
}

const Root = styled.div`
  justify-content: center;

  width: 313px;
  margin-top: 16px;
  justify-self: center;
`
const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
`

const Label = styled.span`
  overflow: hidden;
  color: var(--text-12);
  text-overflow: ellipsis;
  white-space: nowrap;

  height: 16px;
  align-self: stretch;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

const Address = styled.div`
  border: 1px solid var(--backgroundA-3);
  background: var(--appearance-1);

  display: grid;
  grid-template-columns: 1fr auto auto;
  align-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  height: 40px;
  padding: 0 16px;

  margin-top: 8px;
`

const Input = styled.input<{ $isValid: boolean }>`
  color: ${(props) => (props.$isValid ? 'var(--text-12)' : 'var(--error-9)')};
  font-size: 12px;
  font-weight: 400;
  height: 40px;

  font-style: normal;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  border: 0;
  caret-color: auto;

  &:placeholder {
    overflow: hidden;
    color: var(--text-7);
    text-overflow: ellipsis;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
`
